import { productTable } from './shared';

export default {
  title: 'Elenco Prodotti',
  url: 'products',
  elements: [productTable]
};
